module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "back-bar flex com-model m-b-15",
    on: {
      "click": _vm.goback
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/arrowleft_icon.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("返回首页")])]), _vm._v(" "), (_vm.compyInfo) ? _c('div', {
    staticClass: "pj-all m-b-15"
  }, [_c('div', {
    staticClass: "pj-compy"
  }, [_c('div', {
    staticClass: "pj-tit"
  }, [_vm._v("用户综合评分")]), _vm._v(" "), _c('star-temp', {
    attrs: {
      "star-num": _vm.$store.state.hrinfo.fullEval
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pj-juti-score"
  }, [_vm._v(_vm._s(_vm.$store.state.hrinfo.fullEval) + "分")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pj-juti"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "pj-juti-tit"
  }, [_vm._v("招聘人员服务：")]), _vm._v(" "), _c('star-temp', {
    attrs: {
      "star-num": _vm.$store.state.hrinfo.hrEval
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pj-juti-score"
  }, [_vm._v(_vm._s(_vm.$store.state.hrinfo.hrEval) + "分")])], 1), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pj-juti-tit"
  }, [_vm._v("招聘流程规范：")]), _vm._v(" "), _c('star-temp', {
    attrs: {
      "star-num": _vm.$store.state.hrinfo.recruitEval
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pj-juti-score"
  }, [_vm._v(_vm._s(_vm.$store.state.hrinfo.recruitEval) + "分")])], 1)]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "pj-juti-tit"
  }, [_vm._v("工作环境情况：")]), _vm._v(" "), _c('star-temp', {
    attrs: {
      "star-num": _vm.$store.state.hrinfo.workEnvEval
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pj-juti-score"
  }, [_vm._v(_vm._s(_vm.$store.state.hrinfo.workEnvEval) + "分")])], 1), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pj-juti-tit"
  }, [_vm._v("生活环境情况：")]), _vm._v(" "), _c('star-temp', {
    attrs: {
      "star-num": _vm.$store.state.hrinfo.liveEnvEval
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pj-juti-score"
  }, [_vm._v(_vm._s(_vm.$store.state.hrinfo.liveEnvEval) + "分")])], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pj-con"
  }, [_c('div', {
    staticClass: "pj-con-head"
  }, [_c('div', {
    staticClass: "pj-tiao"
  }, [_vm._v("求职者评价\n              "), _c('span', [_vm._v("(共" + _vm._s(_vm.pageTotal > -1 ? _vm.pageTotal : 0) + "条)")])])]), _vm._v(" "), _c('div', {
    staticClass: "pj-list"
  }, _vm._l((_vm.rows), function(item) {
    return _c('div', {
      staticClass: "pj-item"
    }, [_c('div', {
      staticClass: "pj-item-img"
    }, [_c('img', {
      attrs: {
        "src": item.workerHead
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "pj-item-info"
    }, [(item.isAnon) ? _c('div', {
      staticClass: "pj-user"
    }, [_vm._v("匿名用户")]) : _c('div', {
      staticClass: "pj-user"
    }, [_vm._v(_vm._s(item.workerName || '匿名用户'))]), _vm._v(" "), _c('div', {
      staticClass: "pj-tot"
    }, [_c('star-temp', {
      attrs: {
        "star-num": item.fullEval
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "pjrecu-list"
    }, [_c('li', [_vm._v("招聘人员服务："), _c('span', [_vm._v(_vm._s(_vm._f("calAttitude")(item.hrEval)))])]), _vm._v(" "), _c('li', [_vm._v("招聘流程规范："), _c('span', [_vm._v(_vm._s(_vm._f("calAttitude")(item.recruitEval)))])]), _vm._v(" "), _c('li', [_vm._v("工作环境情况："), _c('span', [_vm._v(_vm._s(_vm._f("calAttitude")(item.workEnvEval)))])]), _vm._v(" "), _c('li', [_vm._v("生活环境情况："), _c('span', [_vm._v(_vm._s(_vm._f("calAttitude")(item.liveEnvEval)))])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "pj-txt"
    }, [_c('p', [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('div', {
      staticClass: "pj-item-foot flex"
    }, [_c('div', {
      staticClass: "pj-time"
    }, [_c('span', [_vm._v("评价时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.evalAt.split(' ')[0]))])]), _vm._v(" "), _c('div', {
      staticClass: "pj-report flex",
      class: [item.status === 2 ? 'pj-report-examine' : ''],
      on: {
        "click": function($event) {
          _vm.Report(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/company/jubao_icon.png")
      }
    }), _vm._v(" "), (item.status == 0 || item.status == 1) ? _c('span', [_vm._v("举报不实评论")]) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('span', [_vm._v("已举报，请等待运营核实")]) : _vm._e()])])])])
  })), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageTotal),
      expression: "pageTotal"
    }],
    staticStyle: {
      "margin-top": "40px",
      "padding-bottom": "40px"
    },
    attrs: {
      "current-page": _vm.pageNum,
      "page-sizes": [5, 10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrent
    }
  })], 1), _vm._v(" "), (_vm.isReportTan && _vm.reportObj) ? _c('div', [_c('div', {
    staticClass: "ztx-modal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ztx-message-box"
  }, [_c('div', {
    staticClass: "ztx-message-main",
    staticStyle: {
      "width": "580px"
    }
  }, [_c('div', {
    staticClass: "ztx-message-tit"
  }, [_c('div', [_vm._v("举报不实评价")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-guanbi ztx-message-close",
    on: {
      "click": _vm.clodeTan
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jubao-box"
  }, [_c('div', {
    staticClass: "jubao-tit"
  }, [_vm._v("举报对象")]), _vm._v(" "), _c('div', {
    staticClass: "jubap-con",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('div', {
    staticClass: "jubao-ut"
  }, [_c('div', {
    staticClass: "jubao-user"
  }, [_c('span', {
    staticClass: "jubao-user-name"
  }, [_vm._v(_vm._s(_vm.reportObj.reportUser))]), _vm._v(" "), _c('span', {
    staticClass: "jubao-user-text"
  }, [_vm._v("·综合评价：")]), _vm._v(" "), _c('span', {
    staticClass: "jubao-user-score"
  }, [_vm._v(_vm._s(_vm.reportObj.fullEval) + "分")])]), _vm._v(" "), _c('div', {
    staticClass: "jubao-time",
    staticStyle: {
      "color": "#999"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-pingjiashijian"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reportObj.evalAt.split(' ')[0]))])])]), _vm._v(" "), _c('ul', {
    staticClass: "jubao-pj"
  }, [_c('li', [_c('span', [_vm._v("招聘人员服务：")]), _vm._v(" "), _c('span', {
    staticClass: "jubao-pj-we"
  }, [_vm._v(_vm._s(_vm._f("calAttitude")(_vm.reportObj.hrEval)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("招聘流程规范：")]), _vm._v(" "), _c('span', {
    staticClass: "jubao-pj-we"
  }, [_vm._v(_vm._s(_vm._f("calAttitude")(_vm.reportObj.recruitEval)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("工作环境情况：")]), _vm._v(" "), _c('span', {
    staticClass: "jubao-pj-we"
  }, [_vm._v(_vm._s(_vm._f("calAttitude")(_vm.reportObj.workEnvEval)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("生活环境情况：")]), _vm._v(" "), _c('span', {
    staticClass: "jubao-pj-we"
  }, [_vm._v(_vm._s(_vm._f("calAttitude")(_vm.reportObj.liveEnvEval)))])])]), _vm._v(" "), _c('div', {
    staticClass: "jubao-txt"
  }, [_c('i', [_vm._v(_vm._s(_vm.reportObj.content))])])]), _vm._v(" "), _c('div', {
    staticClass: "jubao-tit",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("举报原因")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportReason),
      expression: "reportReason"
    }],
    class: ['jubao-area', _vm.isReportWarnning ? 'jubao-area-error' : ''],
    attrs: {
      "placeholder": "请填写您的举报原因"
    },
    domProps: {
      "value": (_vm.reportReason)
    },
    on: {
      "blur": _vm.reportReasonBlur,
      "focus": _vm.reportReasonFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportReason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jubao-btn",
    class: [_vm.reportReason.length > 0 ? '' : 'jubap-btn-nocondition'],
    on: {
      "click": _vm.goJubao
    }
  }, [_vm._v("立即举报")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583ce12c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/valuation.vue
// module id = 880
// module chunks = 1